
const styles = {
    svg: {
        width: 'auto',
        height: '80px',
    },
};

const LogoFull = () => {
    const logoPath = '/pocteo-platform-logo.svg';

    return (
            <img
                    src={logoPath}
                    alt="Withe Pocteo Platform Logo"
                    style={styles.svg}
            />
    );
};

export default LogoFull;
